import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';

const ProductCard = ({ product }) => {
    const navigate = useNavigate();

    return (
        <div className="group cursor-pointer" style={{ fontFamily: "'Poppins', sans-serif" }}>
            {/* Image Container */}
            <div
                className="relative overflow-hidden bg-[#F8FAF8] mb-3 md:mb-4"
                style={{ paddingBottom: '133.33%' }}
                onClick={() => navigate(`/template1/product/${product.id}`)}
            >
                <img
                    src={product.image}
                    alt={product.name}
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />

                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" />

                {/* Wishlist Button */}
                <button className="absolute top-3 right-3 w-8 h-8 md:w-10 md:h-10 bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-sm hover:bg-[#F8FAF8]">
                    <Heart size={16} className="text-[#1A1A1A]" />
                </button>

                {/* Quick Add */}
                <button className="absolute bottom-3 left-3 right-3 bg-[#2D6A4F] text-white py-2.5 md:py-3 opacity-0 group-hover:opacity-100 transition-opacity hover:bg-[#1B4332] flex items-center justify-center gap-2 text-xs md:text-sm font-medium tracking-wide">
                    Add to Cart
                </button>
            </div>

            {/* Product Info */}
            <div onClick={() => navigate(`/template1/product/${product.id}`)}>
                <h3 className="text-sm md:text-base font-medium text-[#1A1A1A] mb-1 group-hover:text-[#2D6A4F] transition-colors line-clamp-1">
                    {product.name}
                </h3>
                {product.category && (
                    <p className="text-xs md:text-sm text-[#6B7280] mb-1">{product.category}</p>
                )}
                <div className="flex items-center gap-2">
                    <span className="text-sm md:text-base font-semibold text-[#1A1A1A]">{typeof product.price === 'number' ? `\u20B9${product.price.toLocaleString('en-IN')}` : product.price}</span>
                    {product.originalPrice && (
                        <span className="text-xs md:text-sm text-[#9CA3AF] line-through">{typeof product.originalPrice === 'number' ? `\u20B9${product.originalPrice.toLocaleString('en-IN')}` : product.originalPrice}</span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
